"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledBalance = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 2 0 auto;\n"])));

var StyledBalanceLabel = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  color: ", ";\n  margin-bottom: 0.175rem;\n"])), function (props) {
  return props.theme.colorLabel;
});

var StyledBalanceValue = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: ", ";\n"])), function (props) {
  return props.theme.colorSuccess;
});

var StyledDepositButton = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: 0 0 auto;\n"])));

var StyledStatus = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));

var StyledStatusBadge = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  margin: 0 0.375rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", ";\n  ", ";\n\n  & > span {\n    color: white;\n    font-size: 9px;\n  }\n"])), function (p) {
  return p.isSuccess && "background: ".concat(p.theme.colorSuccess);
}, function (p) {
  return !p.isSuccess && "background: ".concat(p.theme.colorDanger);
});

var StyledStatusText = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  ", ";\n"])), function (p) {
  return !p.isSuccess && "color: ".concat(p.theme.colorLabel);
});

var WalletFloatingHeader = function WalletFloatingHeader(_ref) {
  var position = _ref.position,
      balance = _ref.balance,
      isScrolledDown = _ref.isScrolledDown,
      phoneVerified = _ref.phoneVerified,
      cardAdded = _ref.cardAdded;
  return /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FloatingHeader, {
    position: position,
    justifyContent: "space-between",
    isScrolledDown: isScrolledDown
  }, /*#__PURE__*/_react.default.createElement(StyledBalance, null, /*#__PURE__*/_react.default.createElement(StyledBalanceLabel, null, "Balance"), /*#__PURE__*/_react.default.createElement(StyledBalanceValue, null, "\xA3", /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.PenceToPounds, null, balance))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(StyledStatus, null, /*#__PURE__*/_react.default.createElement(StyledStatusBadge, {
    isSuccess: phoneVerified
  }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.MatIcon, null, phoneVerified ? "check" : "close")), /*#__PURE__*/_react.default.createElement(StyledStatusText, {
    isSuccess: phoneVerified
  }, "Phone Verified"), /*#__PURE__*/_react.default.createElement(StyledStatusBadge, {
    style: {
      marginLeft: "1.25rem"
    },
    isSuccess: cardAdded
  }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.MatIcon, null, cardAdded ? "check" : "close")), /*#__PURE__*/_react.default.createElement(StyledStatusText, {
    isSuccess: cardAdded
  }, "Card Added"))));
};

var _default = WalletFloatingHeader;
exports.default = _default;